import i18n from 'modules/core/lib/i18n'

import type { SectionType } from './types'

export function sectionLabel(section: SectionType): string {
  switch (section) {
    case 'general_information':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.sections.general_information'
      )
    case 'vendor_contact':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.sections.vendor_contact'
      )
    case 'notes_and_delivery':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.sections.notes_and_delivery'
      )
    case 'line_item_columns':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.sections.line_items'
      )
  }
}

export function fieldLabel(labelKey: string): string {
  switch (labelKey) {
    case 'general_information.po_number':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.po_number')
    case 'general_information.order_date':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.order_date')
    case 'general_information.due_date':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.due_date')
    case 'general_information.currency':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.currency')
    case 'general_information.legal_entity':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.legal_entity'
      )
    case 'general_information.requester':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.requester')
    case 'general_information.department':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.department')
    case 'general_information.payment_terms':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.payment_terms'
      )
    case 'general_information.payment_method':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.payment_method'
      )
    case 'general_information.cost_center':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.cost_center')
    case 'general_information.project':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.project')
    case 'vendor_contact.vendor':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.vendor')
    case 'vendor_contact.vendor_id_number':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.vendor_id_number'
      )
    case 'vendor_contact.vendor_tax_id':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.vendor_tax_id'
      )
    case 'vendor_contact.address':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.address')
    case 'vendor_contact.vendor_email':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.vendor_email'
      )
    case 'vendor_contact.vendor_ledger_account':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.vendor_ledger_account'
      )
    case 'notes_and_delivery.delivery_instructions':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.delivery_instructions'
      )
    case 'notes_and_delivery.notes':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.notes')
    case 'line_item_columns.line_number':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.line_number')
    case 'line_item_columns.item_code':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.item_code')
    case 'line_item_columns.description':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.description')
    case 'line_item_columns.quantity':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.quantity')
    case 'line_item_columns.uom':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.uom')
    case 'line_item_columns.unit_price':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.unit_price')
    case 'line_item_columns.discount_percentage':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.discount_percentage'
      )
    case 'line_item_columns.discount_amount':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.fields.discount_amount'
      )
    case 'line_item_columns.subtotal':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.subtotal')
    case 'line_item_columns.tax_rate':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.tax_rate')
    case 'line_item_columns.tax_amount':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.tax_amount')
    case 'line_item_columns.cost_center':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.cost_center')
    case 'line_item_columns.total':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.total')
    case 'line_item_columns.project':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.fields.project')
    default:
      return labelKey
  }
}

/** Returns the i18n-translated sample value for a key-value section field. */
export function previewValue(fieldKey: string): string {
  switch (fieldKey) {
    case 'po_number':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.po_number')
    case 'order_date':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.order_date')
    case 'due_date':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.due_date')
    case 'currency':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.currency')
    case 'legal_entity':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.preview.legal_entity'
      )
    case 'requester':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.requester')
    case 'department':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.department')
    case 'payment_terms':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.preview.payment_terms'
      )
    case 'payment_method':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.preview.payment_method'
      )
    case 'vendor':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.vendor')
    case 'vendor_id_number':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.preview.vendor_id_number'
      )
    case 'address':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.address')
    case 'vendor_email':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.preview.vendor_email'
      )
    case 'vendor_ledger_account':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.preview.vendor_ledger_account'
      )
    case 'gi_cost_center':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.preview.gi_cost_center'
      )
    case 'gi_project':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.gi_project')
    case 'delivery_instructions':
      return i18n.t(
        'procurement.purchase_requests.settings.po_templates.detail.preview.delivery_instructions'
      )
    case 'notes':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.preview.notes')
    default:
      return '\u2014'
  }
}

/** Returns the i18n-translated sample text for a line-item text field at the given row. */
export function previewLineItemText(rowIndex: number, fieldKey: string): string {
  if (rowIndex === 0) {
    switch (fieldKey) {
      case 'item_code':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_1_item_code'
        )
      case 'description':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_1_description'
        )
      case 'uom':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_1_uom'
        )
      case 'cost_center':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_1_cost_center'
        )
      case 'project':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_1_project'
        )
      default:
        return '\u2014'
    }
  }
  if (rowIndex === 1) {
    switch (fieldKey) {
      case 'item_code':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_2_item_code'
        )
      case 'description':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_2_description'
        )
      case 'uom':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_2_uom'
        )
      case 'cost_center':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_2_cost_center'
        )
      case 'project':
        return i18n.t(
          'procurement.purchase_requests.settings.po_templates.detail.preview.row_2_project'
        )
      default:
        return '\u2014'
    }
  }
  return '\u2014'
}

/** Returns the i18n-translated label for a footer total (Net, Tax, Total). */
export function totalsLabel(key: 'net' | 'tax' | 'total'): string {
  switch (key) {
    case 'net':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.totals_net')
    case 'tax':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.totals_tax')
    case 'total':
      return i18n.t('procurement.purchase_requests.settings.po_templates.detail.totals_total')
  }
}
